import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const  gajiPotonganService = {}

gajiPotonganService.data = function (token,data='') {
    return fetch({
        url: '/transaksi/gaji_potongan/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

gajiPotonganService.data_import = function (token,data) {
    return fetch({
        url: '/transaksi/gaji_potongan/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

gajiPotonganService.empty_import = function (token,data) {
    return fetch({
        url: '/transaksi/gaji_potongan/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

gajiPotonganService.save_import = function (token,data) {
    return fetch({
        url: '/transaksi/gaji_potongan/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}


export default gajiPotonganService;
